import { Theme, useMediaQuery } from '@mui/material'
export const useScreenSize = () => {
  const isLargeSize = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('2xl')
  )

  const isMiddleSize = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('xl')
  )

  return {
    isLargeSize,
    isMiddleSize,
  }
}
